import cn from 'classnames';
import PropTypes from 'prop-types';
import {useCallback, useEffect, useRef} from 'react';
import RfidIcon from 'infrastructure/assets/svg/scanner.svg';
import _debounce from 'lodash/debounce';
import PermissionManager from 'infrastructure/js/utils/permissionManager';

import './rfidScanInput.scss';


const handleFocusOn = (elem) => {
  if (elem) {
    elem.readOnly = true;
    elem.focus();
    setTimeout(function () {
      elem.readOnly = false;
    }, 500);
  }
}

export default function RfidScanInput (props) {

  const {className, onScanInputChanged, isFocused, action} = props;
  const inputRef = useRef(null);

  const handheldScannerDebounceMs = PermissionManager?.getOrgPreferences()?.handheldScannerDebounceMs || 250;

  function handleDebounceFn(inputValue) {
    onScanInputChanged?.(inputValue);

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.value = '';
      }
    })
  }

  const debounceFn = useCallback(_debounce(handleDebounceFn, handheldScannerDebounceMs), []);

  const onChangeHandler = (e) => {
    if (e.target.value) {
      debounceFn(e.target.value);
    }
  }

  useEffect(() => {
    if (isFocused) {
      handleFocusOn(inputRef?.current);
    }
    else {
      inputRef?.current?.blur();
    }

  }, [isFocused]);

  const restoreFocus = (event) => {
    let relatedTarget = event.relatedTarget;

    if (relatedTarget) {
      // if ( !relatedTarget.classList?.value?.includes('message-dialog')) {
      handleFocusOn(inputRef?.current);
      // }
    }
  }


    return (
      <div className={cn('rfid-scan-input',  className)} onClick={() => {action?.()}}>
        <div className="scan-scan-input-content">
          <RfidIcon/>
          <textarea ref={inputRef}
                    onBlur={restoreFocus}
                    onInput={onChangeHandler}
                    className="barcode-hidden-input"/>
        </div>
      </div>
    );
}

RfidScanInput.propTypes = {
  className: PropTypes.string,
  onScanInputChanged: PropTypes.func,
  isFocused: PropTypes.bool,
  action: PropTypes.func,
}
